export const OWN = "1";
export const OWN_IN_TRUST = "2";
export const RENT = "3";

export default Object.freeze({
  [OWN]: "Own",
  [OWN_IN_TRUST]: "Own - In Trust",
  [RENT]: "Rent"
});
